import { useEffect } from "react";
import { Typography, Button } from "@mui/material";

// Extend Window interface for Teams script
declare global {
  interface Window {
    shareToMicrosoftTeams?: {
      renderButtons: () => void;
    };
  }
}

const TeamsButton = ({ shareLink }: { shareLink: string }) => {
  useEffect(() => {
    // Ensure the Teams script is loaded and render buttons
    const renderTeamsButton = () => {
      if (window.shareToMicrosoftTeams) {
        window.shareToMicrosoftTeams.renderButtons();
      }
    };

    // Try to render immediately if script is already loaded
    renderTeamsButton();

    // Also listen for when the script loads
    window.addEventListener("load", renderTeamsButton);

    return () => {
      window.removeEventListener("load", renderTeamsButton);
    };
  }, [shareLink]);

  return (
    <Button className="flex flex-col items-center rounded-xl">
      <div
        className="teams-share-button"
        data-href={shareLink}
        data-icon-px-size="65"
        style={{
          borderRadius: "90px",
          marginBottom: -3,
        }}
      />
      <Typography variant="h6">Teams</Typography>
    </Button>
  );
};

export default TeamsButton;
